import { useEffect } from 'react';
import { skipToken } from '@reduxjs/toolkit/query';
import { Stack } from '@mui/material';

import useCooperativeId from 'shared/hooks/useCooperativeId';
import useDispatch from 'shared/hooks/useDispatch';
import StyledFiltersBar from 'shared/components/styled/FiltersBar';

import { userCommonCasesApi } from './api';

import PageLayout from 'layouts/PageLayout';
import SearchBar from './components/SearchBar';
import TopBar from './components/TopBar';
import UserCommonCasesGrid from './components/UserCommonCasesGrid';

const CommonCases = () => {
  const coopId = useCooperativeId();
  const dispatch = useDispatch();

  const { isLoading, isFetching, isError } =
    userCommonCasesApi.useGetCommonCasesQuery(coopId ?? skipToken);

  useEffect(
    () => () => {
      dispatch(userCommonCasesApi.util.resetApiState());
    },
    []
  );

  return (
    <PageLayout isLoading={isLoading} isError={isError}>
      <Stack spacing={2}>
        <TopBar />
        <StyledFiltersBar
          alignItems="center"
          direction="row"
          justifyContent="flex-end"
        >
          <SearchBar />
        </StyledFiltersBar>
        <UserCommonCasesGrid isFetching={isFetching} />
      </Stack>
    </PageLayout>
  );
};

export default CommonCases;
